// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2V0jO","header":"ReportDetails_header__27KM0","title":"ReportDetails_title__2gEXW","left":"ReportDetails_left__1-n8I"};